import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import {
  SeriesItem,
  ISaveModule,
  SaveModule,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import ModuleForm from "./ModuleForm";

type ModuleCreateFormProps = {
  onModuleCreated: () => void;
  onCancel: () => void;
  series: SeriesItem;
};

const ModuleCreateForm = ({
  onModuleCreated,
  onCancel,
  series,
}: ModuleCreateFormProps) => {
  const { formatMessage: t } = useIntl();
  const { seriesService } = useGlobalContext();

  const onSubmit = async (values: ISaveModule) => {
    try {
      await seriesService.saveModule(series.id, new SaveModule(values));
      onModuleCreated();
    } catch (err) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <ModuleForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      series={series}
      submitLabel={t({ id: "moduleFormCreateButton" })}
    />
  );
};

export default ModuleCreateForm;
